import { Box, Flex, Image } from "@chakra-ui/react";

import { Pagination, Table } from "@nens/chakra/components";

import { UserCreateModal } from "@/features/user/components/user-create-modal";
import { UserDeleteButton } from "@/features/user/components/user-delete-button";
import { UserWriteAccessToggle } from "@/features/user/components/user-write-access-toggle";
import {
  useTablePaginationAfterQuery,
  useTablePaginationBeforeQuery,
} from "@/hooks/use-table-pagination";
import { useUserListQuery } from "@/queries/query-users";

export function UsersPage() {
  const { page, setPage, tableQueryParams, pageAmountQueryParams } =
    useTablePaginationBeforeQuery();

  const tableQueryResult = useUserListQuery(tableQueryParams);
  const pageAmountQueryResult = useUserListQuery(pageAmountQueryParams);

  const { isLoading, tableData, itemsPerPage, numPages, toPage1, toPrevious, toNext, toLastPage } =
    useTablePaginationAfterQuery({
      tableQueryResult,
      pageAmountQueryResult,
      page,
      setPage,
    });

  return (
    <Flex p={10} flexDir="column" gap={4}>
      <Flex justifyContent="space-between">
        <Box>
          <Image alt="klimaatscan logo" h="50px" src="/assets/images/klimaatscan-logo.png" />
        </Box>
        <Box>
          <UserCreateModal />
        </Box>
      </Flex>

      <Table
        isLoading={isLoading}
        emptyText="Er zijn geen gebruikers beschikbaar"
        themeColor="brand.primary"
        tableData={tableData}
        columnDefinitions={[
          {
            title: "Gebruikers",
            renderFunction: (row) => row.email,
            width: "1fr",
          },
          {
            title: "Schrijfrechten",
            renderFunction: (row) => <UserWriteAccessToggle user={row} />,
            width: "1fr",
          },
          {
            title: undefined,
            renderFunction: (row) => (
              <Flex w="full" justifyContent="flex-end">
                <UserDeleteButton user={row} />
              </Flex>
            ),
            width: "1fr",
          },
        ]}
      />
      <Flex justifyContent="center">
        <Pagination
          {...{
            itemsPerPage,
            page,
            numPages,
            toPage1,
            toPrevious,
            toNext,
            toLastPage,
            variant: "secondary",
          }}
        />
      </Flex>
    </Flex>
  );
}
